import { Inject, Injectable, Optional } from "@angular/core";
import { MAT_DATE_LOCALE, NativeDateAdapter } from "@angular/material/core";

@Injectable()
export class AdapterDate extends NativeDateAdapter{

    constructor(@Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string) {
        super(dateLocale);
      }

    format(date: Date, displayFormat: Object): string {
        // Não mutar o Date recebido: ele é o valor do FormControl e o datepicker
        // chama format() a cada render. Mutar aqui (setHours +3) fazia a data
        // "andar" para o dia seguinte, estourar o [max]="today" e invalidar o
        // campo ao salvar com o valor padrão. Trabalhamos sobre um clone.
        const d = new Date(date.getTime())
        d.setHours(d.getHours() + 3)

        return `${d.getDate().toString().padStart(2,"0")}/${(d.getMonth() + 1).toString().padStart(2,"0")}/${d.getFullYear()}`
    }

    parse(value: any, parseFormat?: any): Date {
        // Entrada digitada no padrão pt-BR "dd/MM/yyyy"
        if (typeof value === 'string' && value.includes('/')) {
            const [day, month, year] = value.split('/').map((part) => Number(part))
            if (day && month && year) {
                return new Date(year, month - 1, day)
            }
        }

        return new Date(value)
    }




}